import { render, staticRenderFns } from "./RelatorioEmpresa.vue?vue&type=template&id=4a6478b6"
import script from "./RelatorioEmpresa.vue?vue&type=script&lang=js"
export * from "./RelatorioEmpresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports